const mergeSolutions = (solution, state, that) => {
  const updated = Object.assign(state.solutions, solution);
  that.setState({ solutions: updated });
}

export default mergeSolutions;